import type { ThemeColors, ThemePreset } from "../types";
import { sharedTokens } from "../tokens";

export const lightColors: ThemeColors = {
  background: "214 47% 97%",
  foreground: "220 50% 16%",
  card: "0 0% 100%",
  cardForeground: "220 50% 16%",
  popover: "0 0% 100%",
  popoverForeground: "220 50% 16%",
  primary: "145 82% 26%",
  primaryForeground: "0 0% 100%",
  secondary: "214 47% 97%",
  secondaryForeground: "145 82% 26%",
  muted: "212 45% 94%",
  mutedForeground: "215 16% 42%",
  accent: "212 45% 94%",
  accentForeground: "145 82% 26%",
  destructive: "8 64% 44%",
  destructiveForeground: "0 0% 100%",
  border: "214 42% 88%",
  input: "214 32% 80%",
  ring: "219 76% 29%",
  sidebar: "0 0% 100%",
  sidebarForeground: "220 50% 16%",
  sidebarBorder: "214 42% 88%",
  sidebarAccent: "214 47% 96%",
  success: "149 79% 26%",
  warning: "43 80% 46%",
  info: "209 90% 41%",
  brandAccent: "219 76% 29%",
  brandAccentForeground: "0 0% 100%",
  authGradientWarm: "0 0% 100%",
  authGradientCool: "214 47% 97%",
  authAccentBlue: "219 76% 29%",
  authAccentGreen: "145 82% 26%",
  authShadow: "145 82% 26%",
};

export const lightTheme: ThemePreset = {
  name: "light",
  colors: lightColors,
  ...sharedTokens,
};
